import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    filterData: [],
    searchValue: "",
}

const filterDataSlice = createSlice({
    name: 'filterDatas',
    initialState,
    reducers: {
        setFilterData: (state, action) => {
            state.filterData = action.payload
        },
        setSearchData: (state, action) => {
            state.searchValue = action.payload
        }
    }
})

export const { setFilterData, setSearchData } = filterDataSlice.actions

export default filterDataSlice.reducer